import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesStackedCrossOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M13.748 2.034C13.152.742 11.442.5 8 .5S2.848.742 2.252 2.034a9 9 0 0 1 1.575-.377C4.982 1.479 6.379 1.43 8 1.43s3.018.049 4.174.227c.55.084 1.08.203 1.574.377"
                        fill="currentColor"
                    />
                    <path d="M3.334 7.7h9.333V6.3H3.334z" fill="currentColor" />
                    <path d="M3.667 10.534h4.667v-1.4H3.667z" fill="currentColor" />
                    <path
                        d="M8 2.83c-6.439 0-8.028.792-7.359 6.335S2.23 15.5 8 15.5q.345 0 .666-.004v-1.4Q8.349 14.1 8 14.1c-1.43 0-2.466-.05-3.246-.189-.765-.135-1.173-.337-1.433-.56-.256-.22-.502-.578-.725-1.28-.228-.722-.4-1.7-.565-3.074-.34-2.812.04-3.62.496-3.983.284-.226.786-.445 1.726-.59C5.185 4.28 6.402 4.23 8 4.23s2.815.05 3.747.194c.94.145 1.442.364 1.726.59.438.35.805 1.107.534 3.652h1.407C15.925 3.574 14.241 2.83 8 2.83"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16 12.667a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0m-4.182 0-.99-.99.848-.849.99.99.99-.99.849.849-.99.99.99.99-.849.848-.99-.99-.99.99-.848-.849z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
CardLinesStackedCrossOutlinedSize16Glyph.displayName = 'CardLinesStackedCrossOutlinedSize16Glyph';
